import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarCheck, Users, Share2, ListChecks } from 'lucide-react';
import Section from './Section';

const BLOCKS = [
  { icon: ListChecks, t: 'What you get every week', d: 'Recording support, editing, mixing, show notes, artwork, transcripts and publishing to Spotify, Apple and YouTube, plus a promotion plan for each episode.' },
  { icon: Users, t: 'Topics and guests that build authority', d: 'We map episodes to the questions your clients ask and suggest guests whose audiences overlap with yours, so every show strengthens your positioning.' },
  { icon: Share2, t: 'One episode, every channel', d: 'Each recording feeds YouTube, Shorts, LinkedIn posts, a search-led article and your business website, and can become chapters for a future book.' },
  { icon: CalendarCheck, t: 'A rhythm you can keep', d: 'One recording session a week. A 4-week minimum, then cancel any time. Launching from scratch? Our podcast launch service gets you live in under 30 days.' },
];

export const PodcastAuthoritySection = () => (
  <Section bg="white" testId="pm-authority" id="authority-podcasting">
    <p className="text-[#BC516F] font-semibold text-sm uppercase tracking-widest">Authority podcasting</p>
    <h2 className="font-display font-bold text-[#1E2A44] text-3xl sm:text-4xl tracking-tight mt-2 max-w-3xl">Build authority with a podcast, without becoming a full-time producer.</h2>
    <p className="text-[#475569] mt-4 max-w-3xl leading-relaxed">
      A podcast is the fastest way for coaches, consultants and authors to show how they think. Done properly, it becomes the engine
      behind your thought leadership: weekly proof of your expertise that also feeds every other channel.
    </p>
    <div className="mt-10 grid md:grid-cols-2 gap-5">
      {BLOCKS.map(({ icon: Icon, t, d }) => (
        <div key={t} className="bg-[#F6F8FB] border border-[#E2E8F0] rounded-[14px] p-6 flex gap-4">
          <span className="w-10 h-10 shrink-0 rounded-full bg-gradient-to-br from-[#A7468A] to-[#BC516F] flex items-center justify-center"><Icon className="w-5 h-5 text-white" /></span>
          <div>
            <h3 className="font-display font-semibold text-[#1E2A44] text-lg">{t}</h3>
            <p className="text-[#475569] mt-1.5 text-[15px] leading-relaxed">{d}</p>
          </div>
        </div>
      ))}
    </div>
    <p className="mt-8 text-[#475569]">
      See it in action: <Link to="/case-studies/thrive-katie-bell" className="text-[#BC516F] hover:text-[#A7468A] font-semibold">211 episodes for a business coach</Link>, or start with our{' '}
      <Link to="/podcast-launch" className="text-[#BC516F] hover:text-[#A7468A] font-semibold">podcast launch service</Link>.
    </p>
  </Section>
);
